import { Mobile } from "./types";
import { ICamera } from "@/store/views/types";

export function getDefaultState(): Mobile {
    return {
        MobileUser: {
            showDirections: true,
            manualLocationUpdate: false,
        },
        DispatchGuard: {
            guardId: null,
            onDuty: false,
            isCoverAvailable: false,
            callSign: "",
            originalCallSign: "",
            unavailableReason: "",
            unavailableStatusId: 0,
            isRightSideBarOpen: false,
            isLeftSideBarOpen: false,
            almostArrived: false,
            hasArrived: false,
            status: "",
			statusEnum: 0,
            currentTourStepIdentifier: "",
        },
        CallSigns: [],
		CoverCallSigns: [],
		CoverRequested: false,
		CoverRequest: null,
		LeftSidebar: {
        	CoverPickerShown: false,
			UnavailablePickerShown: false,
			HasCoverRequest: false
		},
        ProximityCallSigns: [],
		DeviceLocation: "",
		IsWatchingLocation: false,
        DispatchRequests: [],
        FocalPoint: null,
        AuditEndpoint: "",
        MobileFeatures: {
            isSOSEnabled: false,
            isBreakCoverEnabled: true,
            isLostModeEnabled: false,
            isManualRaiseEnabled: false,
            isClaimedEnabled: false,
            isFileUploadEnabled: true
        },
        DispatchNotesForEvent: [],
        MobileGuardsForEvent: [],
        UnavailableStatuses: [],
        LiveDevice: { title: "Live Cameras" } as ICamera,
        MobileMode: "",
        MainComponentName: "",
        RightComponentName: "",
        MapEnabled: false,
        StarredDevices: [],
		NotificationText: "",
		ManageDataLoading: true,
		ManageGuards: [],
		ManagePatrolZones: [],
		ManageEvents: [],
		ManageAlarmQueueFilters: [],
		ManageCurrentAlarmQueueFilters: [],
		MapGoto: null,
        QuickCloseList: [],
        CurrentTour: null,
        PatrolZones: [],
        UserSharedEventIds: []
    }
}
